<div class="title-1 px-20 pt-20">Confirmation of change</div>
<form (ngSubmit)="confirm()" [formGroup]="passwordForm">
  <div class="password-confirm subtitle-2" mat-dialog-content>
    <div>For security measures, you need to enter your password to confirm the change.</div>
    <mat-form-field class="mt-10">
      <mat-label>Password</mat-label>
      <input formControlName="password" matInput required type="password" />
      @if (password.hasError('required')) {
        <mat-error> Password is <strong>required</strong> </mat-error>
      }
      @if (password.hasError('notValid')) {
        <mat-error class="mat-error"> Your password could not be validated. Please review your information </mat-error>
      }
    </mat-form-field>
  </div>
  <mat-divider class="mx-20!" />
  <mat-dialog-actions [ngClass]="{ biggerButtons: data?.biggerButtons }">
    <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
    <button matButton="elevated" class="red-button" [disabled]="passwordForm.invalid || pending" type="submit">
      CONFIRM
    </button>
  </mat-dialog-actions>
</form>
